module.exports = __webpack_public_path__ + "img/new_page.1ad21e7c.svg";